import { Modal, Box, Typography } from "@mui/material";
import React from "react";
import DashboardTable from "../Dashboard/DashboardTable";
import AppContainer from "../AppContainer";

export default function ServiceModal({ data, open, setOpen }) {
  const displayRows = [
    "serviceName",
    "servicePrice",
    "serviceDuration",
    "teamMemberName",
  ];

  const headerData = [
    {
      id: 1,
      label: "Service Name",
    },
    {
      id: 2,
      label: "Service Price",
    },
    {
      id: 3,
      label: "Service Duration",
    },
    {
      id: 4,
      label: "Team Member Name",
    },
  ];
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ minWidth: "50%", bgcolor: "white" }}>
        <AppContainer primaryHeading={"Selected Service Details"}>
          <DashboardTable
            showHeader={true}
            headerData={headerData}
            tableData={data}
            diplayRows={displayRows}
          />
        </AppContainer>
      </Box>
    </Modal>
  );
}
